import { reportWarning } from './error-handling-service';

const SafeLocalStorage = module.exports;

SafeLocalStorage.check = () => {

  let isLocalStorageOk = false;

  try {
    localStorage.setItem('testLocalStorage', 'pending');
    localStorage.removeItem('testLocalStorage');
    isLocalStorageOk = true;
  } catch(error) {
    reportWarning('UNAVAILABLE_LOCAL_STORAGE_WARNING', error);
  }

  return isLocalStorageOk;

};



/** WEBPACK FOOTER **
 ** ./src/utils/safe-localstorage.js
 **/